export const FORM_CS_DECLARATION_ITEMS = [
  {
    key: "isRevBelow5M",
    label:
      "The company's revenue for the financial year is $5,000,000 or below.",
  },
  {
    key: "isOnlyIncTxbl17",
    label:
      "The company derives only income taxable at 17%.",
  },
  {
    key: "isNotClaimingSpecificItems",
    label:
      "The company is not claiming / utilising carry-back of current year capital allowances/losses, group relief, investment allowance, or foreign tax credit and tax deducted at source.",
  },
  {
    key: "isFullAndTrueAccOfCompInc",
    label:
      "This return gives a full and true account of the whole of the company's income for the financial period ending in the preceding year.",
  },
  {
    key: "isQualifiedToUseConvFormCS",
    optional: true,
    label:
      "The company maintains SGD as functional currency, is not an investment holding or related-party service company only, and does not own subsidiaries, associates, joint ventures, or investment in intangibles.",
  },
];

export const FORM_CS_FINAL_CONFIRMATION_LABEL =
  "I confirm that I have read and agreed to all the above declarations, that the information provided in this Form C-S submission is true, correct, and complete to the best of my knowledge, and that I am authorised to submit this return on behalf of the company.";

export const FORM_CS_TAX_AGENT_DECLARATION_LABEL =
  "I confirm that I am acting as an authorised tax agent for this company, have obtained authority to submit this Form C-S on its behalf, and have reviewed the return with the company or its authorised representative.";
